import { DEFAULT_CURRENCY, boardContents, boardMeta, boardStatus, type User } from '@closetly/core';
import { useState } from 'react';
import { useMembership } from '../lib/membership';
import { useItems, useMe } from '../lib/queries';
import { navigate } from '../lib/router';
import { BoardNameSheet } from './BoardNameSheet';
import { Collage } from './Collage';

/** All boards as covers, Pinterest style. */
export function BoardsPage({ user }: { user: User }) {
  const m = useMembership(user.id);
  const items = useItems(user.id);
  const me = useMe(user);
  const [naming, setNaming] = useState(false);
  const currency = me.data?.currency || DEFAULT_CURRENCY;
  const all = items.data ?? [];

  return (
    <>
      {m.boards.length === 0 ? (
        <div className="empty">
          <strong>Noch keine Boards</strong>
          Leg Boards wie „Herbst“ oder „Urlaub“ an und merk dir darin Outfits und einzelne Teile. Ein Teil kann in
          beliebig vielen Boards sein.
        </div>
      ) : (
        <div className="board">
          {m.boards.map((b) => {
            const c = boardContents(b, m.outfits, all);
            const href = `/boards/${b.id}`;
            return (
              <a
                key={b.id}
                className="pin"
                href={href}
                onClick={(e) => {
                  e.preventDefault();
                  navigate(href);
                }}
              >
                {/* the cover shows its first three pieces */}
                <Collage pieces={c.pieces.slice(0, 3)} />
                <span className="pin-meta">
                  <strong>{b.name}</strong>
                  <span>{boardMeta(c, boardStatus(c.pieces), currency)}</span>
                </span>
              </a>
            );
          })}
        </div>
      )}

      <button className="fab" type="button" onClick={() => setNaming(true)}>
        + Board
      </button>
      {naming && (
        <BoardNameSheet
          title="Neues Board"
          onClose={() => setNaming(false)}
          onSave={(name) => {
            setNaming(false);
            navigate(`/boards/${m.createBoard(name)}`);
          }}
        />
      )}
    </>
  );
}
